import { Component } from '@angular/core';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { AlertService } from './infrastructure/services/alert.service';
import { SxTranslationService } from './infrastructure/services/translation-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  private codeRegex = '[^/]*';

  constructor(private breadcrumbService: BreadcrumbService,
    private alertService: AlertService, private sxTranslationService: SxTranslationService) {

    // Inicializamos el servicio de alertas en el componente principal
    // para asegurarnos de tener la subscripción a errores del backend
    // desde el inicio de la Aplicación
    this.alertService.init();

    breadcrumbService.hideRouteRegex('./confRegla$');
    breadcrumbService.hideRouteRegex('./confFormulario$');
    breadcrumbService.hideRouteRegex('./sxfDesigner$');
    breadcrumbService.hideRouteRegex('./sxfdesigner$');
    breadcrumbService.hideRouteRegex(`./confAssets/${this.codeRegex}$`);
    breadcrumbService.hideRouteRegex(`./confAssets/${this.codeRegex}/${this.codeRegex}/${this.codeRegex}$`);

    breadcrumbService.hideRouteRegex('./confOpciones/editar$');
    breadcrumbService.hideRouteRegex('./confOpciones/detalle$');

    breadcrumbService.hideRouteRegex(`./historial/${this.codeRegex}$`);
    this.addFriendlyNameForRouteRegex('/soc/settings', 'Settings');
    breadcrumbService.hideRoute('/soc/nuevo/editar');
    breadcrumbService.hideRouteRegex('./ventaAsync$');
    breadcrumbService.hideRouteRegex('./cotizacionAsync$');
    breadcrumbService.hideRouteRegex('./service$');
    breadcrumbService.hideRouteRegex('./userAdmin$');
    breadcrumbService.hideRouteRegex('./designer$');
    breadcrumbService.hideRouteRegex('./SrvUsuario$');
    breadcrumbService.hideRouteRegex('./editar$');
   
    breadcrumbService.hideRouteRegex('./UsersAdmin/usersAdmin$');
    this.addFriendlyNameForRouteRegex('/UsersAdmin/usersAdmin/Alta', 'Alta');
    this.addFriendlyNameForRouteRegex('/UsersAdmin/usersAdmin/import', 'Import');

    breadcrumbService.hideRouteRegex(`./sxfdesigner/${this.codeRegex}/${this.codeRegex}$`);

    breadcrumbService.hideRouteRegex(`./Flow/${this.codeRegex}/${this.codeRegex}Event$`);
    breadcrumbService.hideRouteRegex(`./Flow/${this.codeRegex}/${this.codeRegex}Event/${this.codeRegex}Event$`);

    breadcrumbService.hideRouteRegex('./nuevoBackoffice/excel$');
    breadcrumbService.hideRouteRegex('./nuevoBackoffice/inbroker$');

    breadcrumbService.hideRouteRegex('./subscriptions$');
    breadcrumbService.hideRouteRegex('./channels$');
    breadcrumbService.hideRouteRegex('./products$');

    breadcrumbService.addFriendlyNameForRoute('/soc', 'SOC');
    breadcrumbService.hideRoute('/soc/home');
    breadcrumbService.hideRouteRegex('./Flow$');

    this.addFriendlyNameForRouteRegex('./users$', 'USERS');
    this.addFriendlyNameForRouteRegex('./marketplace$', 'MARKETPLACE');
    this.addFriendlyNameForRouteRegex('./RolesAdministracion$', 'PROFILES');
    this.addFriendlyNameForRouteRegex('./userRoles$', 'USER_PROFILES');
    this.addFriendlyNameForRouteRegex('./userRoles$', 'USER_PROFILES');
    this.addFriendlyNameForRouteRegex('./solicitud$', 'SOLICITUDES');
    this.addFriendlyNameForRouteRegex('./confAssets$', 'Assets');
    this.addFriendlyNameForRouteRegex('./historial$', 'HISTORIAL');
    this.addFriendlyNameForRouteRegex('./confOpciones/nuevo$', 'NUEVO');
    this.addFriendlyNameForRouteRegex('./nuevo$', 'NUEVO');
    this.addFriendlyNameForRouteRegex('./transacciones$', 'TRANSACCIONES');
    this.addFriendlyNameForRouteRegex('./nuevoBackoffice$', 'NEW_BACKOFFICE');

    this.addFriendlyNameForRouteRegex('./import-flow', 'IMPORT_FLOW');

    this.addFriendlyNameForRouteRegex(`./Flow/${this.codeRegex}/sxfDesigner$`, 'PAGE_FORM');
    this.addFriendlyNameForRouteRegex(`./Flow/${this.codeRegex}/InteractionEvent/${this.codeRegex}$`, 'INTERACTION_RULES');

    this.addFriendlyNameForRouteRegex(`./monitoreo$`, 'MONITOREO');
    this.addFriendlyNameForRouteRegex(`./sponsor$`, 'SPONSOR');

    breadcrumbService.addCallbackForRouteRegex(`./confOpciones$`, this.confOpcionesBreadcrum.bind(this));
    breadcrumbService.addCallbackForRouteRegex(`./confRegla/${this.codeRegex}$`, this.reglaBreadcrum.bind(this));
    breadcrumbService.addCallbackForRouteRegex(`./confFormulario/${this.codeRegex}$`, this.formularioBreadcrum.bind(this));
    breadcrumbService.addCallbackForRouteRegex(`./sxfdesigner/${this.codeRegex}$`, this.formularioDinamicoBreadcrum.bind(this));
    breadcrumbService.addCallbackForRouteRegex(`./ventaAsync/${this.codeRegex}$`, this.ventaAsyncBreadcrum.bind(this));
    breadcrumbService.addCallbackForRouteRegex(`./cotizacionAsync/${this.codeRegex}$`, this.cotizacionAsyncBreadcrum.bind(this));

    this.addFriendlyNameForRouteRegex(`./settings$`, 'Settings');
    this.addFriendlyNameForRouteRegex(`./categoriasProducto$`, 'Product Categories');
    this.addFriendlyNameForRouteRegex(`./confProductReport$`, 'PRODUCT_REPORT');
    this.addFriendlyNameForRouteRegex(`${this.backofficesUrl()}$`, 'BACKOFFICES');

    this.addFriendlyNameForRouteRegex(`${this.organizationsUrl()}$`, 'ORGANIZATIONS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionsUrl()}$`, 'SUBSCRIPTIONS');

    // Subscription Configuration
    breadcrumbService.addCallbackForRouteRegex(`${this.subscriptionUrl()}/usuarios/${this.codeRegex}/${this.codeRegex}/${this.codeRegex}$`,
      this.comandoUsuarioBreadcrum.bind(this));
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/editar$`, 'EDITAR');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/negocios$`, 'NEGOCIOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/sistemas$`, 'SISTEMAS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/productos$`, 'PRODUCTOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/opciones$`, 'TOOLS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/importacion$`, 'IMPORTACION_MASIVA');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/providers$`, 'PROVIDERS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/restaurarEntidades$`, 'restaurarEntidades');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/opciones/initializer$`, 'Initializer');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/opciones/initializer/importar$`, 'IMPORTAR');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/opciones/initializer/exportar$`, 'EXPORTAR');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/usuarios$`, 'USUARIOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/testapi$`, 'USUARTESTS_APIIOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/siteTemplates$`, 'SITE_TEMPLATES');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/BuscadorProducto$`, 'BUSCADOR_PRODUCTOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/consultaSimple$`, 'CONSULTA_SIMPLE');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/consultaSimple/sistemas$`, 'NIVEL_SISTEMAS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/consultaSimple/negocios$`, 'NIVEL_NEGOCIOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/consultaSimple/productos$`, 'NIVEL_PRODUCTOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/opciones/parametros$`, 'PARAMETROS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/diagnosticos$`, 'DIAGNOSTICOS');
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/usersAndProfiles$`, 'USERS_AND_PROFILES');

    // System Set up
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/confSistema$`, 'CONFIGURACION');
    //this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/confSistema/externalComponents$`, 'EXTERNAL_COMPONENTS');

    // Outputs
    this.addFriendlyNameForRouteRegex(`${this.subscriptionUrl()}/confSistema/outputs$`, 'OUTPUTS');
    this.addFriendlyNameForRouteRegex(`${this.outputConfigurationUrl()}$`, 'OUTPUT_CONFIGURATION');
    this.addFriendlyNameForRouteRegex(`${this.outputConfigurationUrl()}/mapping$`, 'MAPPING');
    this.addFriendlyNameForRouteRegex(`${this.outputConfigurationUrl()}/import$`, 'IMPORT_LAYOUT');
    this.addFriendlyNameForRouteRegex(`${this.outputConfigurationUrl()}/configuration$`, 'CONFIGURACION');
    this.addFriendlyNameForRouteRegex(`${this.outputConfigurationUrl()}/pushConfiguration$`, 'PUSH_CONFIGURATION');

    // Channels
    this.addFriendlyNameForRouteRegex(`${this.channelsUrl()}$`, 'CHANNELS');

    // Digital Library
    //this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/digital-library$`, 'SMARTIX_DIGITAL_LIBRARY');
    //this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/digital-library/${this.codeRegex}/import`, 'TEMPLATE_FORM');

    // API Key
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/authorizationConfiguration$`, 'API_ACCESS');

    // Channel Set up
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/confNegocio$`, 'CONFIGURACION');
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/alias$`, 'Alias');
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/buscarProductos$`, 'BUSCADOR_PRODUCTOS');
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/alias/template$`, 'Templates');
    this.addFriendlyNameForRouteRegex(`${this.channelUrl()}/alias/template/confSponsor$`, 'Sponsor');

    // Products
    this.addFriendlyNameForRouteRegex(`${this.productsUrl()}$`, 'PRODUCTS');

    // Product Set up
    this.addFriendlyNameForRouteRegex(`${this.productUrl()}/confProducto$`, 'CONFIGURACION');
    this.addFriendlyNameForRouteRegex(`${this.productUrl()}/confReport$`, 'REPORT_CONFIGURATION');
    this.addFriendlyNameForRouteRegex(`${this.productUrl()}/publish$`, 'PUBLISH_PRODUCT');
  }

  private addFriendlyNameForRouteRegex(routeRegex: string, name: string) {
    this.breadcrumbService.addFriendlyNameForRouteRegex(routeRegex, this.sxTranslationService.getResource(name));
  }

  private reglaBreadcrum(id: string) {
    return this.sxTranslationService.getResource('REGLA_BREADCRUM', { id: id });
  }

  private confOpcionesBreadcrum(id: string) {
    return this.sxTranslationService.getResource('CONF_OPCIONES_BREADCRUM', { id: id });
  }

  private formularioBreadcrum(id: string) {
    return this.sxTranslationService.getResource('FORMULARIO_BREADCRUM', { id: id });
  }

  private formularioDinamicoBreadcrum(id: string) {
    return this.sxTranslationService.getResource('FORMULARIO_DINAMICO_BREADCRUM', { id: id });
  }

  private ventaAsyncBreadcrum(id: string) {
    return this.sxTranslationService.getResource('SaleAsync ' + id);
  }

  private cotizacionAsyncBreadcrum(id: string) {
    return this.sxTranslationService.getResource('QuoteAsync ' + id);
  }

  private comandoUsuarioBreadcrum(codComando: string) {
    return this.sxTranslationService.getResource('SrvUsuario_' + codComando);
  }

  // URL Functions
  private backofficesUrl() {
    return '/soc/backoficces';
  }

  private organizationsUrl() {
    return '/soc/organizations';
  }

  private organizationUrl() {
    return `${this.organizationsUrl()}/${this.codeRegex}`;
  }

  private subscriptionsUrl() {
    return `${this.organizationUrl()}/subscriptions`;
  }

  private subscriptionUrl() {
    return `${this.subscriptionsUrl()}/${this.codeRegex}`;
  }

  private channelsUrl() {
    return `${this.subscriptionUrl()}/channels`;
  }

  private channelUrl() {
    return `${this.channelsUrl()}/${this.codeRegex}`;
  }

  private productsUrl() {
    return `${this.channelUrl()}/products`;
  }

  private productUrl() {
    return `${this.productsUrl()}/${this.codeRegex}`;
  }

  private outputConfigurationUrl() {
    return `${this.subscriptionUrl()}/outputs/${this.codeRegex}/confOutput`;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/app.component.ts